import {ActionCreator, TypedAction} from '@ngrx/store/src/models';
import {createAction, props} from '@ngrx/store';
import {Serializers} from '../../interfaces/serializer';
import {GeneralDimension} from '../../interfaces/dimensions';

export const loadGeneralDimensions: ActionCreator<'[GENERAL_DIMENSIONS] Load', () => TypedAction<'[GENERAL_DIMENSIONS] Load'>> = createAction('[GENERAL_DIMENSIONS] Load');

export const loadGeneralDimensionsSuccess: ActionCreator<
  '[GENERAL_DIMENSIONS] Load success',
  (props: { dimensions: Serializers<GeneralDimension> }) => TypedAction<'[GENERAL_DIMENSIONS] Load success'> & { dimensions: Serializers<GeneralDimension> }
> = createAction('[GENERAL_DIMENSIONS] Load success', props<{ dimensions: Serializers<GeneralDimension> }>())

export const loadPublicGeneralDimensions: ActionCreator<
  '[GENERAL_DIMENSIONS] Load public',
  (props: { token: string, uuid: string }) => TypedAction<'[GENERAL_DIMENSIONS] Load public'> & { token: string, uuid: string }
> = createAction('[GENERAL_DIMENSIONS] Load public', props<{ token: string, uuid: string }>());
export const loadPublicGeneralDimensionsSuccess: ActionCreator<
  '[GENERAL_DIMENSIONS] Load public success',
  (props: { dimensions: Serializers<GeneralDimension> }) => TypedAction<'[GENERAL_DIMENSIONS] Load public success'> & { dimensions: Serializers<GeneralDimension> }
> = createAction('[GENERAL_DIMENSIONS] Load public success', props<{ dimensions: Serializers<GeneralDimension> }>());

export const updateGeneralDimensions: ActionCreator<'[GENERAL_DIMENSIONS] Update all', () => TypedAction<'[GENERAL_DIMENSIONS] Update all'>> = createAction('[GENERAL_DIMENSIONS] Update all');

export const updateGeneralDimensionsSuccess: ActionCreator<
  '[GENERAL_DIMENSIONS] Update all success',
  (props: { dimensions: Serializers<GeneralDimension> }) => TypedAction<'[GENERAL_DIMENSIONS] Update all success'> & { dimensions: Serializers<GeneralDimension> }
> = createAction('[GENERAL_DIMENSIONS] Update all success', props<{ dimensions: Serializers<GeneralDimension> }>())
